import React from "react";
import BulkUploadFile from "../../components/BulkUploadFile";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as BulkInventoryUploadActions from "../../store/actions/BulkInventoryUpload";

const instructions = [
  "Please provide data as per the format in the sample file.",
  "Please try to open your sample csv file always with MS excel or google sheets but don't open with other editors.",
];

const BulkInventoryUploadDashboard = ({ getBulkUploadUrl }) => {
  return (
    <BulkUploadFile
      instructions={instructions}
      btnDataTestID="BulkInventoryUploadBtn"
      uploadUrl="/inventory/bulk/upload/ack"
      sampleURL="/sample/bulk_inventory_upload.csv"
      id="BulkInventoryUploadModal"
      sendExtraAck={true}
      keyName="callback_key"
      heading="Bulk Inventory Upload"
      getUploadUrl={getBulkUploadUrl}
    />
  );
};

function mapDispatchToProps(dispatch) {
  return {
    getBulkUploadUrl: bindActionCreators(
      BulkInventoryUploadActions.getUploadUrl,
      dispatch
    ),
  };
}

export default connect(null, mapDispatchToProps)(BulkInventoryUploadDashboard);
